import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormFactorsComponent } from './form-factors.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [FormFactorsComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [FormFactorsComponent]
})
export class FormFactorsModule { }
